module.exports = __webpack_public_path__ + "static/media/error_401.c3622fa3.png";